import React from "react";
import { Outlet } from "react-router-dom";
import DashboardTopNav from "../../components/DashBoard/DashboardTopNav";
import "./dashboardAppShell.css";

export default function DashboardLayout() {
  return (
    <div className="dashboardAppShell">
      <DashboardTopNav />
      <div className="dashboardAppOutlet">
        <Outlet />
      </div>
    </div>
  );
}
